/**
 * ธาตุของการโจมตีกายภาพ (ผู้ใช้อนุมัติ 9 ต.ค. 2026)
 *
 * สายดาบ หมัด ธนู มีด ได้ธาตุคนละวิธี แต่ทุกทางมารวมที่ `attackElement` ที่เดียว:
 *   1. ธาตุของสกิล (มีอยู่แล้ว) ชนะเสมอ
 *   2. ธาตุชั่วคราว — บัฟสกิลที่มี `endow` (ดาบเสกธาตุ · ท่าหมัด · เคลือบมีด) หรือของกิน `endow`
 *      (น้ำมันเคลือบธาตุ · ลูกศรธาตุ) อันที่ได้มาล่าสุดชนะ ("สลับท่า" = ร่ายอีกท่าทับ)
 *   3. ธาตุถาวรของอาวุธ — ร่ายที่โรงตีเหล็กด้วยหินธาตุ + โกลด์ (ตัวเผาเงินหลัก) เก็บเป็นบรรทัดออปชัน `el_<ธาตุ>`
 *   4. ไร้ธาตุ
 * เวทที่ไม่มีธาตุของสกิลไม่รับธาตุอาวุธ (ธาตุอาวุธเป็นของสายกายภาพ)
 *
 * **ร่ายธาตุใช้โกลด์กับของในเกมเท่านั้น ห้ามเพชร** (กฎข้อ 2) · pure function
 */
import { ELEMENT_NAMES } from "./types.js";
/** คำนำหน้า id บรรทัดออปชันที่เป็นธาตุอาวุธ */
export const ENDOW_PREFIX = "el_";
/** ธาตุที่ร่ายใส่อาวุธได้ (ไร้ธาตุไม่ต้องร่าย) */
export const ENDOW_ELEMENTS = ["earth", "water", "fire", "wind", "poison", "holy", "dark", "ice"];
export function isEndowElement(v) {
    return typeof v === "string" && ENDOW_ELEMENTS.includes(v);
}
export function endowOptionId(el) {
    return `${ENDOW_PREFIX}${el}`;
}
/** อ่านธาตุจาก id บรรทัดออปชัน ไม่ใช่บรรทัดธาตุ = undefined */
export function endowOf(optionId) {
    if (!optionId.startsWith(ENDOW_PREFIX))
        return undefined;
    const el = optionId.slice(ENDOW_PREFIX.length);
    return isEndowElement(el) ? el : undefined;
}
/** ธาตุถาวรของอาวุธจากรายการออปชัน */
export function weaponEndow(options) {
    for (const o of options ?? []) {
        const el = endowOf(o.id);
        if (el)
            return el;
    }
    return undefined;
}
/** แทนที่ (หรือใส่ใหม่) บรรทัดธาตุ บรรทัดออปชันอื่นไม่เปลี่ยน */
export function withEndow(options, el) {
    return [...options.filter((o) => !endowOf(o.id)), { id: endowOptionId(el), v: 1 }];
}
/** ชื่อหินธาตุ (วัตถุดิบ) ของแต่ละธาตุ */
export function endowStoneId(el) {
    return `stone_el_${el}`;
}
/** โกลด์ต่อเลเวลอาวุธที่ใช้ร่ายธาตุ (ตามที่ผู้ใช้อนุมัติ: 300 × เลเวลอาวุธ) */
export const ENDOW_GOLD_PER_LV = 300;
/** ค่าร่ายธาตุถาวร — เปลี่ยนธาตุใหม่จ่ายเต็มทุกครั้ง (ตัวเผาเงินระยะยาว) */
export function endowCost(def, el) {
    return { gold: ENDOW_GOLD_PER_LV * Math.max(1, def?.reqLevel ?? 1), stone: endowStoneId(el) };
}
/** ธาตุของการโจมตีครั้งหนึ่ง ตามลำดับความสำคัญด้านบน */
export function attackElement(o) {
    if (o.skillElement)
        return o.skillElement;
    if (o.magic)
        return undefined;
    let best;
    for (const t of o.temp ?? []) {
        if (t.until <= o.now)
            continue;
        if (!best || t.since > best.since)
            best = t;
    }
    return best?.element ?? o.weapon;
}
export function describeEndow(el) {
    return `ธาตุอาวุธ: ${ELEMENT_NAMES[el]}`;
}
//# sourceMappingURL=endow.js.map